// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__ELF_j","header":"MergedInvoice_header__2d8ZY"};